import React from 'react';
import PropTypes from "prop-types";

const Loading = ({message}) => {
	return (
		<div className="this-is-loading">
			<h5 className="is-5">{message}</h5>
			<br/>
			<i className="fa fa-spin fa-spinner fa-3x black-text"></i>
		</div>
	)
}

Loading.propTypes = {
	message: PropTypes.string
}

export default Loading;


// WEBPACK FOOTER //
// ./src/elements/loading.jsx